export function getToolbarConfig({
  i18n,
  lazyInject,
}) {
  // eslint-disable-next-line
  const toolbarSelectedConfig = new Map([

  ]);

  // eslint-disable-next-line
  const toolbarUnselectedConfig = new Map([
    ['button-add-brand', {
      id: 'button-add-brand',
      type: 'button',
      classes: ['btn-primary'],
      text: i18n.getString(_TL_('Add brands')),
      iconLeftGlyphName: 'ba-Add',
      onClick() {
        const gridView = lazyInject().backboneGridView;
        gridView.AddBrandToolbar();
      },
    }],
    ['expander', {
      type: 'expander',
    }],
    ['search-box-filter', {
      id: 'search-box-filter',
      type: 'search-box',
      placeholder: i18n.getString(_TL_('Brand name')),
      handleChange: (value) => {
        const gridView = lazyInject().backboneGridView;
        gridView.onBrandSearch(value);
      },
    }],
  ]);
  return {
    toolbarSelectedConfig,
    toolbarUnselectedConfig,
  };
}
